import React, { useState } from 'react'
import Chart from 'react-apexcharts'

const SupplierGraph = () => {
  const [supplierData] = useState({
    suppliers: [
      'CocoaCrafters Inc',
      'SweetHarvest Co.',
      'DivineCocoa Distributors',
      'ChocoHarvest Suppliers',
      'GoldenBean Enterprise'
    ],
    data: [91.75, 94.13, 91.09, 91.95, 89.97]
  })

  // ApexCharts options for bar graph
  const options: any = {
    chart: {
      type: 'line' // Change the type to 'bar'
    },
    xaxis: {
      categories: supplierData.suppliers // Set categories as supplier names
    }
  }

  // ApexCharts series for bar graph
  const series = [
    {
      name: 'Supplier Availability',
      data: supplierData.data.map((dataPoint) => parseFloat(dataPoint.toFixed(2))) // Limiting to 1 decimal place
    }
  ]

  return (
    <div className='card'>
      <div className='card-body d-flex flex-column p-0'>
        <div className='flex-grow-1 card-p pb-0'>
          <div className='d-flex flex-stack flex-wrap'>
            <div className='me-2'>
              <div className='text-dark text-hover-primary fw-bolder fs-4 fs-md-6'>
                Supplier Availability
              </div>
            </div>
          </div>
        </div>
        <Chart options={options} series={series} type='line' height={500} />
      </div>
    </div>
  )
}

export default SupplierGraph
